import { RouteLocation, Router } from 'vue-router'
import { computed } from 'vue'

// getModalStackFromRoute returns all modal routes belonging to the given route.
const getModalStackFromRoute = (route: RouteLocation) => {
  if (route.matched) {
    const modalStack = route.matched.filter((route) => route.meta.isModal)
    if (modalStack) {
      return modalStack
    }
  }
  return []
}

// Returns true if the user clicked on the backdrop directly and not on a child element of it.
const isBackdropClick = (e: MouseEvent) => e.target instanceof Element && e.target.classList.contains('modal-stack__backdrop')

export function useModalStack (router: Router) {
  const stack = computed(() => getModalStackFromRoute(router.currentRoute.value))

  const close = async () => {
    const currentRoute = router.currentRoute.value

    const parent = currentRoute.matched[currentRoute.matched.length - 2]
    if (parent) {
      const params: Record<string, string> = {}
      if (parent.meta.recycleRouteParams && Array.isArray(parent.meta.recycleRouteParams)) {
        parent.meta.recycleRouteParams.forEach((param: string) => {
          if (!Array.isArray(param) && !Array.isArray(currentRoute.params[param])) {
            params[param] = currentRoute.params[param]
          }
        })
      }
      await router.push({ name: parent.name , params })
    }
  }

  // onClick handles a click on the backdrop.
  const onClick = async (e: MouseEvent) => {
    if (!isBackdropClick(e)) {
      return
    }
    await close()
  }

  return {
    close,
    stack,
    onClick,
  }
}
